var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#009EDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8182 16.0002C19.5259 16.0002 20.9091 14.617 20.9091 12.9093C20.9091 11.2015 19.5259 9.81836 17.8182 9.81836C16.1105 9.81836 14.7273 11.2015 14.7273 12.9093C14.7273 14.617 16.1105 16.0002 17.8182 16.0002ZM10.8636 14.4547V12.9093C10.8636 12.4843 10.5159 12.1365 10.0909 12.1365C9.66591 12.1365 9.31818 12.4843 9.31818 12.9093V14.4547H7.77273C7.34773 14.4547 7 14.8024 7 15.2274C7 15.6524 7.34773 16.0002 7.77273 16.0002H9.31818V17.5456C9.31818 17.9706 9.66591 18.3184 10.0909 18.3184C10.5159 18.3184 10.8636 17.9706 10.8636 17.5456V16.0002H12.4091C12.8341 16.0002 13.1818 15.6524 13.1818 15.2274C13.1818 14.8024 12.8341 14.4547 12.4091 14.4547H10.8636ZM17.8182 17.5456C15.755 17.5456 11.6364 18.5811 11.6364 20.6365V21.4093C11.6364 21.8343 11.9841 22.182 12.4091 22.182H23.2273C23.6523 22.182 24 21.8343 24 21.4093V20.6365C24 18.5811 19.8814 17.5456 17.8182 17.5456Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/onboarding.da0c8ee04df994e867b7acf578e556eb.svg";
export { ForwardRef as ReactComponent };